<template>
	<div class="PopAddSubAccounts">
		<el-dialog :visible.sync="dialogVisible" :lock-scroll="false">
			<div class="tianjiazizhanghao">
				<div class="pop-header">
					<div class="ph-title">
						<span v-if="ruleForm.userId">修改子账号</span>
						<span v-else>添加子账号</span>
					</div>
					<div class="ph-close pointer" @click="close"></div>
				</div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="pop-body">
					<div class="cb-row">
						<div class="cbr-label">用户昵称：</div>
						<div class="cbr-content">
							<el-form-item prop="name" class="form-item yanzhengma">
								<el-input v-model="ruleForm.name" class="input type-1" placeholder="请输入"
									clearable></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="cb-row">
						<div class="cbr-label">联系方式：</div>
						<div class="cbr-content">
							<el-form-item prop="phone" class="form-item">
								<el-input v-model="ruleForm.phone" class="input type-1" placeholder="请输入手机号"
									clearable></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="cb-row">
						<div class="cbr-label">登录账号：</div>
						<div class="cbr-content">
							<el-form-item prop="account" class="form-item">
								<el-input v-model="ruleForm.account" class="input type-1" placeholder="账号由数字、字母、汉字组成,长度2-20个字符"
									clearable></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="cb-row">
						<div class="cbr-label">登录密码：</div>
						<div class="cbr-content">
							<el-form-item prop="password" class="form-item">
								<el-input v-model="ruleForm.password" class="input type-1" placeholder="请输入"
									clearable></el-input>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div class="pop-footer">
					<div class="pf-cancel btn-fill" @click="close">取消</div>
					<div class="pf-confirm btn-fill" @click="submit">确定</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		UserAddSubAccounts,
		UserUpSubAccounts
	} from '../common/api.js'
	var that = {}
	var ruleForm = {
		name: '', // 姓名
		password: '', // 密码
		userId: '', // 子账号ID
		phone: '', // 手机号
		avatar: '', // 头像
		account: '', // 头像
	}
	export default {
		name: 'PopUpdatePass', //添加子账号
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			var phoneChecked = (rule, value, callback) => {
				if (this.verifyPhone({val: value, showToast: false})) {
					callback();
				} else {
					return callback(new Error(rule.message));
				}
			};
			var accountChecked = (rule, value, callback) => {
				if (this.verifyAccount({val: value, showToast: false})) {
					callback();
				} else {
					return callback(new Error(rule.message));
				}
			};
			var lengthChecked = (rule, value, callback) => {
				if (this.verifyLength({val: value, showToast: false, min: 2, max: 20})) {
					callback();
				} else {
					return callback(new Error(rule.message));
				}
			};

			return {
				dialogVisible: false,
				ruleForm: {
					...ruleForm
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名'
					}],
					password: [{
						required: true,
						message: '请输入密码'
					}],
					account: [{
							required: true,
							message: '请输入账号'
						}, {
							message: '请勿输入数字、字母、汉字以外的字符',
							validator: accountChecked
						}, {
							message: '字符长度应在2到20位之间',
							validator: lengthChecked,
							trigger: 'blur',
						},
					],
					phone: [{
						trigger: 'blur',
						message: '手机号格式不正确',
						validator: phoneChecked
					}],
				},

			}
		},
		watch: {
			show: {
				handler: function(val) {
					this.dialogVisible = val
				},
				immediate: true
			},
			dialogVisible: {
				handler: function(val) {
					if (!val) {
						this.$refs.ruleForm.resetFields()
					}
					this.$emit('update:show', val)
				}
			},
			

		},
		created() {
			that = this
		},
		methods: {
			open(data) {
				if (!data) {
					this.ruleForm = {
						...ruleForm
					}
				} else {
					this.ruleForm.name = data.name
					this.ruleForm.password = ''
					this.ruleForm.userId = data.id
					this.ruleForm.phone = data.phone
					this.ruleForm.avatar = data.avatar
					this.ruleForm.account = data.account
				}
				this.dialogVisible = true
			},
			close() {
				this.dialogVisible = false
			},
			submit() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						if (!this.ruleForm.userId) {
							let data = {
								name: this.ruleForm.name, // 姓名
								password: this.ruleForm.password, // 密码
								phone: this.ruleForm.phone, // 手机号
								avatar: this.ruleForm.avatar, // 头像
								account: this.ruleForm.account, // 头像
							}
							console.log('data: ', data);

							UserAddSubAccounts(data).then(res => {
								this.toast({
									message: '添加成功',
									type: 'success'
								})
								this.close()
								this.$emit('addSuccess')
							})
						} else {
							let data = {
								name: this.ruleForm.name, // 姓名
								password: this.ruleForm.password, // 密码
								userId: this.ruleForm.userId, // 密码
								phone: this.ruleForm.phone, // 手机号
								avatar: this.ruleForm.avatar, // 头像
								account: this.ruleForm.account, // 头像
							}
							console.log('data: ', data);

							UserUpSubAccounts(data).then(res => {
								this.toast({
									message: '修改成功',
									type: 'success'
								})
								this.close()
								this.$emit('editSuccess')
							})
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

		}
	}
</script>

<style lang="scss" scoped>
	.PopAddSubAccounts {
		.tianjiazizhanghao {
			min-width: 600px;
			// min-height: 396px;
			background: #FFFFFF;
			border-radius: 8px 8px 8px 8px;
			box-sizing: border-box;
			padding: 0 20px;

			.pop-header {
				height: 56px;
				display: flex;
				align-items: center;
				position: relative;
				border-bottom: 1px solid #EDEDED;

				.ph-title {
					font-size: 16px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #333333;
					line-height: 16px;
				}

				.ph-close {
					width: 16px;
					height: 16px;
					background-image: url('../assets/058.png');
					background-size: 100% 100%;
					position: absolute;
					right: 0;
				}
			}

			.pop-body {
				box-sizing: border-box;
				padding: 0 0 20px;
				display: flex;
				flex-direction: column;

				.cb-row {
					display: flex;
					align-items: center;
					margin: 20px 0 0;

					.cbr-label {
						width: 100px;
						display: flex;
						// justify-content: flex-end;
						font-size: 14px;
						font-family: Microsoft YaHei, Microsoft YaHei;
						font-weight: 400;
						color: #333333;
						box-sizing: border-box;
						padding-right: 10px;

						.star {
							color: #FF0000;
						}
					}

					.cbr-content {
						flex: 1;
						display: flex;
						// align-items: center;

						.cbrc-value {
							font-size: 12px;
							font-family: Microsoft YaHei, Microsoft YaHei;
							font-weight: 400;
							color: #333333;
						}

						.yanzhengma {
							position: relative;

							.yanzhengma-btn {
								position: absolute;
								right: 0;
								top: 0;
								font-size: 12px;
								font-family: Microsoft YaHei, Microsoft YaHei;
								font-weight: bold;
								color: #3571DA;
								line-height: 32px;
								width: 80px;
								text-align: center;
							}
						}

						::v-deep.input {
							input {
								height: 32px;
								font-size: 12px;
								font-family: Microsoft YaHei, Microsoft YaHei;
								font-weight: 400;
								color: #333333;
								padding-left: 8px;
							}

							&.type-1 {
								width: 320px;
							}
						}
					}
				}

			}

			.pop-footer {
				border-top: 1px solid #EDEDED;
				height: 72px;
				display: flex;
				justify-content: center;
				align-items: center;

				.pf-cancel {
					width: 88px;
					height: 32px;
					border-radius: 4px 4px 4px 4px;
					opacity: 1;
					border: 1px solid #3571DA;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 14px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #3571DA;
					line-height: 14px;
					box-sizing: border-box;
					margin: 0 10px;
				}

				.pf-confirm {
					width: 88px;
					height: 32px;
					background: #3571DA;
					border-radius: 4px 4px 4px 4px;
					font-size: 14px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #FFFFFF;
					line-height: 32px;
					text-align: center;
					margin: 0 10px;
				}
			}
		}
	}
</style>